<template>
    <div class="detail-layout buy-layout"
        v-if="isAccountLoaded">
        <CampaignPicture class="layout-picture"
            :imgClass="'default'"
            :campaignImage="detailController.campaign.pictures" />

        <div class="layout-name">{{detailController.campaign.name}}</div>
        <div class="layout-point">
            <div v-html="getPointText(detailController.point, detailController.pointType)"></div>
        </div>
        
        <DetailAndCondition
            :lbl="lbl"
            :userType="userType"
            :campaign="detailController.campaign" />

        <AddToCart 
            :lbl="lbl"
            :locale="locale"
            :isLogin="isLogin"
            :userPoint="point"
            :detailController="detailController"
            @clickAddToCart="clickAddToCart($event)">
        </AddToCart>

        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
//import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
//component
import CampaignPicture from "../detail/Picture.vue";
import DetailAndCondition from "../detail/DetailAndCondition.vue";
import AddToCart from '../detail/AddToCart.vue';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AddToCartModalController } from "@/components/Modal/Controller/AddToCartModalController.js";
import { SubcampaignModalController } from "@/components/Modal/Controller/SubcampaignModalController.js";

export default {
    name: 'BuyLayout',
    mixins: [
        AccountMixin
    ],
    components: {
        CampaignPicture,
        DetailAndCondition,
        AddToCart,
        ModalMaster,
    },
    props: {
        lbl: Object,
        locale: Number,
        userType: String,
        detailController: Object
    },
    computed: {
        // userType: function () {
        //     return this.$store.state.userType;
        // }
    },
    data: function() {
        return {
            cartItem: 0,
            //modal
            modalController: new ModalController(),
            addToCartModal: new AddToCartModalController(),
            subcampaignModal: new SubcampaignModalController(),

            trackingService: new TrackingService(this),
        };
    },
    created: function () {
        this.initialDetailControllerEvent();
        this.modalController.setAddToCartModal(this.addToCartModal);
        this.modalController.setSubcampaignModal(this.subcampaignModal);
    },
    methods: {
        //event
        clickCart: function () {
            console.log('click cart');
            var token = this.getToken();
            var theme = "";
            switch (this.userType){
                case 'farmer':
                    theme = "cpf_farmer";
                    break;
                case 'subdist':
                    theme = "cpf_subdist";
                    break;
                case 'dist':
                    theme = "cpf_dist";
                    break;
                case 'sale':
                    theme = "cpf_sale";
                    break;
                default:
                    theme = "cpf_farmer";
                    break;
            }

            var url = Vue.bzbsConfig.bzbNewShoppingCartUrl + "/?appid=" + Vue.bzbsConfig.client_id + "&token=" + token + "&locale=" + this.localeCode + "&theme="+theme+ "&return_url=" + encodeURIComponent(window.location.href) + "&api=" + Vue.bzbsConfig.api_prefix;
            window.location = url;
        },
        //#region initial
        initialDetailControllerEvent: function () {
            // this.detailController.cbShoppingCart
            //     .onCallback(this.shoppingCart);
                
            this.detailController.cbShoppingCart
                .onCallback(data => {
                    this.cartItem = data;

                    if (this.cartItem > 99)
                        this.cartItem = '99+';

                    this.initialDetailControllerEvent();
                });
        },
        //#endregion initial
        //#region method
        shoppingCart: function () {

        },
        clickAddToCart: function (event) { 
            if(this.detailController.campaign.subCampaignStyles) {
                this.subcampaignModal
                    .clearModal()
                    .setCampaign(this.detailController.campaign)
                    .setDetailController(this.detailController)
                    .setUserPoint(this.point)
                    .show();
                this.subcampaignModal.onClickOk((data) => {
                    this.detailController.setAddToCartParams(data.campaignId, data.qty);
                    this.detailController.addToCart();
                })
            } else {
                this.detailController.setAddToCartParams(this.detailController.campaign.id, event.qty);
                this.detailController.addToCart();
            }
            this.trackingService.event('campaigndetail_page', 'click_add_to_cart', null, null);
        },
        //#endregion method
        //util
        getPointText: function (point, pointType) {
            var pointTypeTxt = pointType && pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.locale === 1033 && point > 1
                        ? this.lbl.detail.point + 's'
                        : this.lbl.detail.point;

            return `${pointTypeTxt} <span class="points">${Util.formatNum(point)}</span> ${pointUnit}`;
            // return pointTypeTxt + point + ' ' + pointUnit;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/module/Detail/component/layout/Layout.scss";
.buy-layout {
    .wrapper-btn {
        // display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 16px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
    }

    #quantity_row {
        display: flex;
        gap: 16px;

        #quantity_input_row {
            width: 60%;
            // flex: 0 0 65%;

            #quantity_input_wrapper {
                display: flex;
                width: 100%;

                .quantity-icon {
                    width: 50px;
                    flex: 0 0 50px;
                    margin: {
                        top: auto;
                        bottom: auto;
                    }

                    img {
                        width: 100%;
                    }

                    &.disable {
                        opacity: 0.3;
                    }

                    &:nth-child(1) {
                        padding-right: 5px;
                    }

                    &:nth-child(3) {
                        padding-left: 5px;
                    }

                    img {
                        display: block;
                        width: 100%;
                    }
                }

                #quantity_input {
                    @include baseRegisterInput;
                    display: inline-block;
                    width: calc(100% - 100px);
                    flex: 0 0 calc(100% - 100px);
                    margin-bottom: 0;

                    .input-wrapper {
                        input {
                            padding: {
                                left: 10px;
                                right: 10px;
                            };

                            text-align: center;
                        }
                    }
                }
            }
        }

        #quantity_btn_row {
            width: 40%;

            .btn-wrapper {
                box-shadow: none !important;
                min-height: 50px !important;

                .btn-txt {
                    font-size: 1.5rem !important;
                }
            }
        }
    }
}
</style>

